import Pusher from 'pusher-js';
import { ApiCall } from 'components/common/services/ApiServices';
import { AJ_WEB_CONNECTOR } from 'Constants';

const pusherKey = process.env.REACT_APP_PUSHER_APP_KEY;
const cluster = process.env.REACT_APP_PUSHER_CLUSTER;


if (!pusherKey || !cluster) {
  throw new Error('Missing Pusher configuration in environment variables');
}

const pusher = new Pusher(pusherKey, {
  cluster,
  forceTLS: true,
  // TO-38127 (f_fesec_cb0cf986c6): private channels (private-whatsapp-chat) now
  // require a server-signed authorization. The public app key alone can no longer
  // subscribe. We reuse the app's authenticated gateway path (ApiCall.service →
  // service-registry → aj-web-connector /broadcasting/auth, guarded by
  // auth:sanctum) so the caller's own bearer token authorizes the subscription.
  // encrypt=false: the auth response is a plain { auth: "..." } payload.
  channelAuthorization: {
    transport: 'ajax',
    endpoint: '',
    customHandler: ({ socketId, channelName }, callback) => {
      ApiCall.service(
        'broadcasting-auth',
        'POST',
        { socket_id: socketId, channel_name: channelName },
        false,
        AJ_WEB_CONNECTOR,
        false
      )
        .then((res: any) => {
          if (res && res.auth) {
            callback(null, res);
          } else {
            callback(new Error('Pusher channel authorization failed'), null);
          }
        })
        .catch((err: any) =>
          callback(err instanceof Error ? err : new Error(String(err)), null)
        );
    },
  },
});

export default pusher;
